import { Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import SectionChart from '../shared/sectionChart/SectionChart';
import SectionHero from '../shared/sectionHero/SectionHero';
import GenderByRole from './charts/GenderByRole';
import GenderSalaryByExperience from './charts/GenderSalaryByExperience';
import GenderSalaryByRole from './charts/GenderSalaryByRole';
import { HERODATA, REPRESENTATIONDATA } from './Gender.constants';
import {
  StyledContainer,
  StyledHighlight,
  StyledItem,
  StyledList,
  StyledSection
} from './Gender.styled';
import GenderCalculator from './GenderCalculator';

const Gender: React.FC = () => {
  const { t } = useI18n('developer-career-report-2023');
  const heroData = HERODATA(t);
  const representationData = REPRESENTATIONDATA(t);

  return (
    <StyledSection>
      <SectionHero
        background={getPublicPath(
          '/images/stateSector/2023/gender-hero-bg.webp'
        )}
        backgroundSm={getPublicPath(
          '/images/stateSector/2023/gender-hero-bg-sm.webp'
        )}
        title={t('mandecar23.gender.hero.title')}
        desc={t('mandecar23.gender.hero.desc')}
        data={heroData}
      />
      <SectionChart
        title={t('mandecar23.gender.gender-by-role.title')}
        desc={t('mandecar23.gender.gender-by-role.desc')}
        descExtra={t('mandecar23.gender.gender-by-role.descExtra')}
      >
        <GenderByRole />
      </SectionChart>
      <StyledHighlight>
        <StyledContainer>
          <Heading3>{t('mandecar23.gender.representation.title')}</Heading3>
          <StyledList>
            {representationData.map((item, index) => (
              <StyledItem key={index}>
                <span>{item.value}</span>
              </StyledItem>
            ))}
          </StyledList>
        </StyledContainer>
      </StyledHighlight>
      <SectionChart
        title={t('mandecar23.gender.salary-by-gender.title')}
        desc={t('mandecar23.gender.salary-by-gender.desc')}
        descExtra={t('mandecar23.gender.salary-by-gender.descExtra')}
      >
        <GenderSalaryByRole />
      </SectionChart>
      <SectionChart
        title={t('mandecar23.gender.calculator.title')}
        desc={t('mandecar23.gender.calculator.desc')}
      >
        <GenderCalculator />
      </SectionChart>
      <SectionChart
        title={t('mandecar23.gender.salary-gender-experience.title')}
        desc={t('mandecar23.gender.salary-gender-experience.desc')}
        descExtra={t('mandecar23.gender.salary-gender-experience.descExtra')}
      >
        <GenderSalaryByExperience />
      </SectionChart>
    </StyledSection>
  );
};

export default Gender;
